exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".electronic-wrapper-container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  height: calc(100vh - 110px); }\n  .electronic-wrapper-container .item-top {\n    height: 80%; }\n  .electronic-wrapper-container .item-bottom {\n    height: 20%; }\n  .electronic-wrapper-container .era-input-era {\n    display: none !important; }\n\n.deposit-wrapper-container {\n  height: 100%; }\n\n.wrapper-deposit-date {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between; }\n  .wrapper-deposit-date .style-btn-clear-input {\n    cursor: pointer; }\n\n.buttons-card {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  -ms-flex-align: end;\n      align-items: end; }\n\n.upper-table {\n  border-collapse: collapse;\n  width: 20%;\n  border: none; }\n\n.low-table {\n  margin-left: 20%;\n  border-collapse: collapse;\n  width: 20%;\n  border: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/billing-general/deposits/electronic/electronic.component.scss
// module id = 1968
// module chunks = 66